// src/schedule/DndProvider.js
import React, { useRef } from 'react';
import { DragDropContext } from '@hello-pangea/dnd';

export default function DndProvider({ onDragEnd, children }) {
    const handle = typeof onDragEnd === 'function' ? onDragEnd : () => { };
    
    return <DragDropContext onDragEnd={handle}>{children}</DragDropContext>;
}